import { ActionSheetViewport } from '@/components/ui/ActionSheet'
import { useOverlayBackGuard } from '@/hooks/useOverlayBackGuard'
import { Outlet } from 'react-router-dom'
import { AppViewport, AppContainer } from '@/components/layout'
import { useAuth } from '@/app/auth/AuthContext'

export function AppLayout() {
  useOverlayBackGuard()
  const { user } = useAuth()
  return <div className={`chef-root${user ? ' chef-root--authenticated' : ''}`}>
    <AppViewport><AppContainer><Outlet /><ActionSheetViewport /></AppContainer></AppViewport>
  </div>
}
